module.exports = __webpack_public_path__ + "img/1.5 px_light_grey.45ca8993.svg";